export default class PreviewAsset {
  public open: boolean
  public url: string

  constructor (open = false, url = '') {
    this.open = open
    this.url = url
  }
}
